import React, { useState, useEffect } from "react";
import axios from "axios"
import AdminDashboard from "./pages/AdminDashboard";
import LoginForm from "./pages/LoginForm";

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));
  const [error, setError] = useState("");

  const handleLogin = async (username, password) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/login`, {
        username,
        password,
      });

      localStorage.setItem("token", response.data.token);
      setIsLoggedIn(true);
    } catch (err) {
      setError("Invalid username or password");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const { exp } = JSON.parse(atob(token.split(".")[1]));
      const expirationTime = exp * 1000 - Date.now();
      if (expirationTime > 0) {
        setTimeout(() => {
          localStorage.removeItem("token");
          setIsLoggedIn(false);
        }, expirationTime);
      } else {
        localStorage.removeItem("token");
        setIsLoggedIn(false);
      }
    }
  }, []);

  // Mock data for the dashboard
  const mockUserData = [
    {
      timestamp: new Date().toISOString(),
      ipFromFrontend: "192.168.1.1",
      ipFromServer: "192.168.1.1",
      geo: {
        latitude: "40.7128",
        longitude: "-74.0060"
      },
      userAgent: "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36",
      cameraImageFilename: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop",
      screenshotFilename: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=200&h=200&fit=crop"
    },
    {
      timestamp: new Date().toISOString(),
      ipFromFrontend: "192.168.1.2",
      ipFromServer: "192.168.1.2",
      geo: {
        latitude: "34.0522",
        longitude: "-118.2437"
      },
      userAgent: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7)",
      cameraImageFilename: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop",
      screenshotFilename: "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=200&h=200&fit=crop"
    },
    {
      timestamp: new Date().toISOString(),
      ipFromFrontend: "192.168.1.3",
      ipFromServer: "192.168.1.3",
      geo: {
        latitude: "51.5074",
        longitude: "-0.1278"
      },
      userAgent: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X)",
      cameraImageFilename: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop",
      screenshotFilename: "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?w=200&h=200&fit=crop"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      {isLoggedIn ? (
        <AdminDashboard onLogout={handleLogout} mockData={mockUserData} />
      ) : (
        <LoginForm onLogin={handleLogin} error={error} />
      )}
    </div>
  );
};

export default App;